<template>
  <div class="analysis">
    <PageHeader :title="title" :items="items" />

    <!-- Filters -->
    <Filters @close="posFilters" />
    <ViewModel :id="idAnalysys" :obj="obj" @accept="accept" @deny="deny" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <div class="row">
            <!-- Items per page -->
            <div class="col-sm-12 col-md-6">
              <div class="row align-items-center mb-2">
                <b-button v-b-modal.modal-filters variant="success" size="sm">
                  Filtros
                </b-button>

                <div class="col-2 m-0">Mostrar&nbsp;</div>
                <div class="col-3 m-0 p-0">
                  <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>
                </div>
                <div class="col-3 m-0 p-0">&nbsp;por página</div>
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="row">
            <div class="col-12">
              <div v-if="analysis.length > 0 && !loading" class="table-responsive mb-0">
                <template>
                  <div>
                    <NewTable :headers="columns" :data="analysis" :canCollapse="true">
                       <template v-slot:cell(cliente)="props">
                        <div class="row-info">
                          <strong class="row-first">
                            {{ props && props.item && props.item.sale && props.item.sale.client && props.item.sale.client.name ? props.item.sale.client.name : "Sem Nome" }}
                          </strong>
                          <div class="row-second-wrapper">
                            <strong class="row-second">
                              {{ props && props.item && props.item.sale && props.item.sale.client && props.item.sale.client.email ? props.item.sale.client.email : "Sem Email" }}
                            </strong>
                            <div :class="['second-indicator', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.email : 0)]">
                               <span :class="['second-indicator-number', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.email : '0')]">
                                  {{ convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.email : '0' }}
                            </span>
                          </div>

                          </div>
                        </div>
                      </template>
                      <template v-slot:additionalData(cliente)="props">
                        <div class="row-second-wrapper" style="margin-top: -10px;">
                          <strong class="row-second">
                            {{ props && props.item && props.item.sale && props.item.sale.client && props.item.sale.client.cellphone ? props.item.sale.client.cellphone : "Sem Cellphone" }}
                          </strong>
                          <div :class="['second-indicator', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.phone : 0)]">
                               <span :class="['second-indicator-number', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.phone : 0)]">
                                  {{ convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.phone : '0' }}
                            </span>
                          </div>
                        </div>
                        <div class="row-second-wrapper">
                          <strong class="row-second">CPF 
                            {{ props && props.item && props.item.sale && props.item.sale.client && props.item.sale.client.cpf_cnpj ? props.item.sale.client.cpf_cnpj : "" }}
                          </strong>
                          <div :class="['second-indicator', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.cpf_cnpj : 0)]">
                               <span :class="['second-indicator-number', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.cpf_cnpj : 0)]">
                                  {{ convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.cpf_cnpj : '0' }}
                            </span>
                          </div>
                        </div>
                      </template>
                      <template v-slot:cell(venda)="props">
                        <div class="row-info">
                          <strong class="row-first">{{ props.item.sale.id }}</strong>
                          <p :class="getStatus(props.item.sale.status).class">{{ getStatus(props.item.sale.status).text }}</p>
                          <div class="row-second-wrapper">
                            <strong class="row-second">{{ isHeaven ? '$' : 'R$' }} {{
                              formatMoney(props.item.sale.amount) }}
                            </strong>
                          </div>
                        </div>
                      </template>
                      <template v-slot:additionalData(venda)="props">
                        <div class="row-second-wrapper" style="margin-top: -10px;">
                          <strong class="row-second">
                            {{ props && props.item && props.item.sale && props.item.sale.client && props.item.sale.client.name ? props.item.sale.client.name : "Sem Nome" }}
                          </strong>
                          <div :class="['second-indicator', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.name : 0)]">
                               <span :class="['second-indicator-number', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.name : 0)]">
                                  {{ convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.name : '0' }}
                            </span>
                          </div>
                        </div>
                        <div class="row-second-wrapper">
                          <PaymentMethodIcon :method="props.item.sale.method" />
                          <strong class="row-second" style="margin-left: 4px;">Cartao 
                            {{ props && props.item && props.item.sale && props.item.sale.client && props.item.sale.client.cpf_cnpj ? props.item.sale.client.cpf_cnpj : "" }}
                            </strong>
                          <div :class="['second-indicator', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.card : 0)]">
                               <span :class="['second-indicator-number', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.card : 0)]">
                                  {{ convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.card : '0' }}
                            </span>
                          </div>
                        </div>                      
                        <strong class="row-second">
                          {{ props && props.item && props.item.sale && props.item.sale.card_first_digits ? props.item.sale.card_first_digits : "" }} **** **** 
                          {{ props && props.item && props.item.sale && props.item.sale.card_last_digits ? props.item.sale.card_last_digits : "" }}
                        </strong>

                      </template>
                      <template v-slot:cell(vendedor)="props">
                        <div class="row-info">
                          <strong class="row-first">
                            {{ props && props.item && props.item.sale && props.item.sale.seller && props.item.sale.seller.id ? props.item.sale.seller.id : "Sem Id" }}
                          </strong>
                          <div class="row-second-wrapper">                   
                            <strong class="row-second">
                              {{ props && props.item && props.item.sale && props.item.sale.seller && props.item.sale.seller.name ? props.item.sale.seller.name : "Sem Nome" }}
                            </strong>
                          </div>
                        </div>
                      </template>
                      <template v-slot:additionalData(vendedor)="props">
                        <div class="row-second-wrapper" style="margin-top: -10px;">
                          <strong class="row-second">
                            {{ props && props.item && props.item.sale && props.item.sale.seller && props.item.sale.seller.email ? props.item.sale.seller.email : "Sem Email" }}
                          </strong>
                        </div>
                        <div class="row-second-wrapper">
                          <strong class="row-second">CPF 
                            {{ props && props.item && props.item.sale && props.item.sale.seller && props.item.sale.seller.cellphone ? props.item.sale.seller.cellphone : "Sem Cellphone" }}
                          </strong>
                        </div>
                      </template>
                      <template v-slot:cell(data_ip)="props">
                        <div class="row-info">
                          <strong class="row-first">{{ props.item.created_at | datetime }}</strong>
                          <div class="row-second-wrapper">
                            <strong class="row-second" v-if="props.item.sale.payment_request">{{
                              props.item.sale.payment_request.ip.slice(0, 8)
                            }}
                            </strong>
                            <p>visitorId</p>
                          <div :class="['second-indicator', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.visitorId : 0)]">
                               <span :class="['second-indicator-number', getClassByCount(convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.visitorId : 0)]">
                                  {{ convertJson(props.item.entity_totalizer) && convertJson(props.item.entity_totalizer).count ? convertJson(props.item.entity_totalizer).count.visitorId : '0' }}
                            </span>
                          </div>
                          </div>
                         <div v-if="props.item.reason">
                          <strong class="row-first">Motivo: </strong>
                          <span v-if="formatReasons(props.item.reason).length <= 15">
                            {{ formatReasons(props.item.reason) }}
                          </span>
                          <span v-else v-b-tooltip.hover :title="formatReasons(props.item.reason)">
                            {{
                              formatReasons(props.item.reason).length >= 15
                                ? formatReasons(props.item.reason).substr(0, 15) + '...'
                                : formatReasons(props.item.reason)
                            }}
                          </span>
                         </div>
                        </div>
                      </template>
                      <template v-slot:cell(score_venda)="props">
                        <NewProgressBar :type="'RiskScore'" :valor="props.item.sale.risk_score ? props.item.sale.risk_score  : 0" class="positionRange"/>
                      </template>
                      
                      <template v-slot:cell(score_vendedor)="props">
                            <graphNew
                            :redirectScore="props.item.sale.seller_id "
                            :data="null"
                            :value="props.item.avg_user_scores ? props.item.avg_user_scores : 0"
                            :max="1000"
                            :link="'/analises/participante/' + props.item.sale.seller_id"
                          />
                       
                      </template>
                      <template v-slot:cell(id_status)="props">
                        <div class="row-info">
                          <div v-b-tooltip.hover.html="formatAnalyzesStatus(props.item.status, props.item.fraud_reason)" class="row-second-wrapper">
                            <strong class="row-first"># {{ props.item.id }}</strong>
                            <div v-if="props.item.status === 'FRAUD'" class="new-tags fraude"></div>
                            <div v-if="props.item.status === 'FALSE_ALARM'" class="new-tags alarme"></div>
                            <div v-if="props.item.status === 'PENDING' || props.item.status === null"
                              class="new-tags aberto"></div>
                          </div>
                        </div>
                      </template>
                      <template v-slot:cell(actions)="props">
                        <div class="actionContainer">
                          <div class="actionContainer__item">
                            <div class="button-action" v-if="canViewRiskSale" @click="goToSale(props.item.id)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path fill="currentColor" d="M245.48 125.57c-.34-.78-8.66-19.23-27.24-37.81C201 70.54 171.38 50 128 50S55 70.54 37.76 87.76c-18.58 18.58-26.9 37-27.24 37.81a6 6 0 0 0 0 4.88c.34.77 8.66 19.22 27.24 37.8C55 185.47 84.62 206 128 206s73-20.53 90.24-37.75c18.58-18.58 26.9-37 27.24-37.8a6 6 0 0 0 0-4.88M128 194c-31.38 0-58.78-11.42-81.45-33.93A134.8 134.8 0 0 1 22.69 128a134.6 134.6 0 0 1 23.86-32.06C69.22 73.42 96.62 62 128 62s58.78 11.42 81.45 33.94A134.6 134.6 0 0 1 233.31 128C226.94 140.21 195 194 128 194m0-112a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46m0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34"/></svg>
                            </div>
                          </div>
                          <div class="actionContainer__item"
                            v-if="props.item.status === 'PENDING' || props.item.status === null">
                            <b-dropdown
                              :disabled="!canEditRiskAnalysisStatus"
                              right
                            >
                              <template v-slot:button-content>
                                <div class="button-action">
                                  <svg width="800px" height="800px" viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg" fill="#000000" class="bi bi-three-dots-vertical">
                                    <path
                                      d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                  </svg>
                                </div>
                              </template>
                              <b-dropdown-item @click="deny(props.item.id)">
                                Reportar como Fraude e Reembolsar
                              </b-dropdown-item>
                              <b-dropdown-item @click="accept(props.item.id)">
                                Reportar como Alarme Falso
                              </b-dropdown-item>
                            </b-dropdown>
                          </div>
                        </div>
                      </template>
                    </NewTable>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div v-if="analysis.length > 0" class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows"></b-pagination>
                </ul>
              </div>
            </div>
          </div>
          <!-- Loading -->
          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <!-- Feedback Message -->
          <div v-if="analysis.length === 0 && !loading" class="row justify-content-center">
            <div class="alert alert-primary" role="alert">
              Sem requisições pendentes.
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import appConfig from '@src/app.config'
import PageHeader from '@components/page-header'
import AnalysisService from '@services/resources/AnalysisService'
import Money from '@src/mixins/money'
import ViewModel from '@components/analysis/view'
import Graph from './graph'
import Filters from './filters'
import _ from 'lodash'
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'
import NewTable from '@/src/components/common/new-table.vue';
import graphNew from '@router/views/analysis/graphNew.vue';
import {AccessLevel} from "@views/configurations/enums/accessLevel";


const service = AnalysisService.build()

export default {
  name: 'AnalyseRisk',
  page: {
    title: 'Análises de Risco',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { PageHeader, ViewModel, Graph, Filters, NewProgressBar, NewTable, graphNew},
  mixins: [Money],
  data() {
    return {
      title: 'Análises de Risco',
      idAnalysys: 0,
      analysis: [],
      solicitation: {},
      loading: true,
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Análises',
          active: true,
        },
      ],
      completedSteps: 1,
      totalSteps: 10,
      animateSpeed: 1000,
      height: 50,
      width: 800,
      showTip: true,
      strokeLinecap: "round",
      startColor: "#bbff42",
      stopColor: "#0413dc",
      innerStrokeColor: "#d6efff",
      timingFunc: "linear",
      totalRows: 10,
      currentPage: 1,
      total: 0,
      totalToPaid: 0,
      perPage: 15,
      pageOptions: [15, 50, 100],
      filter: '',
      filterOn: [],
      filters: {},
      sortBy: 'name',
      sortDesc: false,
      columns: [
        { key: 'cliente', label: 'Cliente', sortable: true },
        { key: 'venda', label: 'Venda', sortable: false },
        { key: 'vendedor', label: 'Vendedor', sortable: false },
        { key: 'data_ip', label: 'Data/IP', sortable: false },
        { key: 'score_venda', label: 'Score venda' },
        { key: 'score_vendedor', label: 'Score vendedor', sortable: false },
        { key: 'id_status', label: 'ID/Status', sortable: false },
        { key: 'actions', label: 'Ações', sortable: false },
      ],
      obj: {
        product: {
          name: null,
        },
        seller: {
          name: null,
          email: null,
          cellphone: null,
          cpf: null,
        },
        client: {
          name: null,
          email: null,
          cellphone: null,
          cpf: null,
        },
        method: null,
        paid_at: null,
        total: 0,
        reason: null,
        risk_body: {},
      },
      watchersEnabled: true,
    }
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
    canViewRiskSale() {
      return this.$canAction('risk_analysis_show_sale', AccessLevel.READER)
    },
    canEditRiskAnalysisStatus() {
      return this.$canAction('risk_analysis_edit_status', AccessLevel.EDITOR)
    },
  },
  watch: {
    async currentPage() {
      if (this.watchersEnabled) {
        await this.fetchAnalysis(this.filters)
      }
    },
    async perPage() {
      if (this.watchersEnabled) {
        this.watchersEnabled = false;
        await this.fetchAnalysis(this.filters).then(() => {
          this.watchersEnabled = true;
        });
      }
    },
    filter() {
      if (this.watchersEnabled) {
        this.debounce()
      }
    },
  },
  async mounted() {
    this.watchersEnabled = false;
    await this.fetchAnalysis().then(() => {
      this.watchersEnabled = true;
    });
  },
  methods: {
    formatAnalyzesStatus(status, fraudReason) {
      let formattedStatus = '';
      let formattedReason = '';

      switch (status) {
          case 'FRAUD': 
              formattedStatus = "Fraude";
              break;
          case 'FALSE_ALARM': 
              formattedStatus = "Alarme falso";
              break;
          case 'PENDING': 
              formattedStatus = "Pendente";
              break;
          default: 
              formattedStatus = "Sem status";
      }

      if (fraudReason) {
        formattedReason = `<br>Motivo: ${this.formatReasons(fraudReason)}`;
      }

      return `${formattedStatus}${formattedReason}`;
    },
    formatReasons(reason) {      
      if (typeof reason === 'string') {
        try {
          reason = JSON.parse(reason);
        } catch (e) {
          return reason;
        }
      }

      if (Array.isArray(reason)) {
        const filteredReasons = reason.filter(r => {
          return r !== null && r.trim() !== '' && !r.toLowerCase().includes('null');
        });

        return filteredReasons.join(', ');
      }

      return reason;
    },
    scoreRedirect(id) {
      const url = '/analises/participante/' + id;
      this.$router.push(url);
    },

    getClassByCount(Count) {
      if (Count > 5) {
        return 'red';
      } else {
        return 'blue';
      }
    },
    convertJson(data){
      if (data) {
        return JSON.parse(data)
      }
    },
    goToSale(sale_id) {
      const url = '/analises/venda/' + sale_id;
      window.open(url, '_blank');
    },
    getStatus(status) {
      if (status) {
        switch (status.toLowerCase()) {
          case 'opened': return { text: 'Aberto', class: 'status-sale status-opened' }
          case 'in_negociation': return { text: 'Em negociação', class: 'status-sale status-in-negociation' }
          case 'objection': return { text: 'Objeção', class: 'status-sale status-objection' }
          case 'lost_trading': return { text: 'Negociação Perdida', class: 'status-sale status-lost-trading' }
          case 'win': return { text: 'Vencemos', class: 'status-sale status-win' }
          case '': return { text: 'list', class: 'status-sale status-red' }
          case 'paid': return { text: 'Pago', class: 'status-sale status-paid' }
          case 'waiting_payment': return { text: 'Aguardando pagamento', class: 'status-sale status-pending' }
          case 'abandoned': return { text: 'Abandonado', class: 'status-sale status-abandoned' }
          case 'canceled': return { text: 'Cancelado', class: 'status-sale status-canceled' }
          case 'trialing': return { text: 'Trial', class: 'status-sale status-trialing' }
          case 'pending_approbation': return { text: 'Liberação manual', class: 'status-sale status-pending-approbation' } 
          case 'pending_refund': return { text: 'Reembolso pendente', class: 'status-sale status-pending-refund' }
          case 'refund_pending': return { text: 'Reembolso pendente', class: 'status-sale status-refund-pending' }
          case 'refused': return { text: 'Recusado', class: 'status-sale status-refused' }
          case 'refunded': return { text: 'Reembolsado', class: 'status-sale status-refunded' }
          case 'chargedback': return { text: 'Estorno', class: 'status-sale status-chargedback' }
          case 'delayed': return { text: 'Em processamento', class: 'status-sale status-delayed' }
          case 'created': return { text: 'Criada', class: 'status-sale status-created' }
          default: return { text: status, class: 'status-sale status-default' }
        }
      } else {
        return { text: '', class: 'status-sale status-default' }
      }
    },
    copyLink(value) {
      // Copy link
      const el = document.createElement('textarea')
      el.value = value
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.$bvToast.toast(
        `Item copiado com sucesso!`,
        {
          title: "Copiado!",
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        }
      );
    },
    setColor(number) {
      if (number === 1 || number === 0) {
        return ''
      } else if (number > 2 && number < 5) {
        return 'aberto'
      } else if (number >= 5) {
        return 'fraude'
      } else {
        return ''
      }
    },
    debounce: _.debounce(async function () {
      await this.fetchAnalysis()
    }, 500),
    async posFilters(filters) {
      this.filters = filters;
      this.currentPage = 1;
      this.watchersEnabled = false;
      await this.fetchAnalysis(this.filters).then(() => {
        this.watchersEnabled = true;
      });
    },
    async fetchAnalysis(filters = {}) {
      this.loading = true
      this.analysis = []

      var data = {
        per_page: this.perPage,
        page: this.currentPage,
      }
      Object.keys(filters).forEach(
        (key) =>
          (filters[key] == null || filters[key].length === 0) &&
          delete filters[key]
      )
      data = Object.assign(data, filters)

      if (this.filter.length) data.search = this.filter

      try {
        const resp = await service.search(data);
        this.analysis = resp.data
        this.currentPage = resp.current_page
        this.totalRows = resp.total
        this.total = resp.total
        this.perPage = resp.per_page
        this.loading = false
      } catch (err) {
        console.error(err)
        this.loading = false
      }
    },
    textMethod(method) {
      if (method) {
        switch (method.toUpperCase()) {
          case 'CREDIT_CARD': return 'CARTÃO DE CRÉDITO'
          case 'TWO_CREDIT_CARDS': return 'DOIS CARTÕES'
          default: return method
        }
      } else return method
    },
    async update(data) {
      await service
        .update(data)
        .then(() => {
          let myArray = this.analysis
          let cutID = parseInt(data.id)
          let index = myArray.findIndex((el) => el.data.id === cutID);
          this.analysis[index].data.status = data.status;
          this.$bvModal.hide('modal-view')
        })
        .catch(err => console.error(err))
    },
    async setAsAlarm(data) {
      await service
        .update(data)
        .then(async(response) => {
          await this.updateAnalysis(data, response);    
        })
        .catch(err => {
          Vue.swal({ html: `Ocorreu um erro!` });
          console.error(err)
        })
    },
    async setAsFraud(data) {
      await service
        .update(data)
        .then(async(response) => {
          await this.updateAnalysis(data, response);    
        })
        .catch(err => {
          Vue.swal({ html: `Ocorreu um erro!` });
          console.error(err)
        })
    },
    async updateAnalysis(data, response) {
      if (response.success) {
        const index = this.analysis.findIndex(item => item.id === data.id);
        
        if (index !== -1) {
          this.$set(this.analysis, index, {
            ...this.analysis[index],
            ...response.data,
          });
        }
      } else {
        Vue.swal({ html: `Ocorreu um erro!` });
      }
    },
    async accept(id) {
      Vue.swal({
        title: 'Análise',
        text: 'Tem certeza que deseja reportar como Alarme Falso? A venda continuará no Greenn.',
        type: 'success',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        inputValidator: (value) => {
          if (value.length <= 10) {
            return "O motivo da fraude deve ter mais de 10 caracteres!";
          }
        }
      }).then(async(result) => {
        if (result.value) {
          await this.setAsAlarm({ id, status: 'FALSE_ALARM', fraud_reason: result.value })
        }
      })
    },
    async deny(id) {
      await Vue.swal({
        title: "Análise",
        text: "Tem certeza que deseja reportar como Fraude? A venda será reembolsada no Greenn.",
        type: 'error',
        input: "text",
        inputPlaceholder: 'Motivo da fraude',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        inputValidator: (value) => {
          if (value.length <= 10) {
            return "O motivo da fraude deve ter mais de 10 caracteres!";
          }
        }
      }).then(async(result) => {
        if (result.value) {
          await this.setAsFraud({ id, status: 'FRAUD', fraud_reason: result.value })
        }
      });
    },
    open(obj) {
      this.idAnalysys = obj.id
      this.obj = obj.sale
      this.obj.risk_body = JSON.parse(obj.sale.risk_body)
      this.obj.reason = obj.reason
      this.$bvModal.show('modal-view')
    },
    parseReasons(reasonString) {
      return reasonString.replace(/[\[\]"']/g, '').split(',');
    }
  }
}
</script>

<style lang="scss" scoped>
p,
span {
  font-family: 'Montserrat';
  font-style: normal;
  margin: 0;
}

.text {
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.2px;
  color: #333333;
  font-weight: 600;
}

.subtext {
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.2px;
  color: #81858e;
  font-weight: 400;
}

.id {
  margin-bottom: 10px;
}

.mb-itens {
  margin-bottom: 7px;
}

.center {
  text-align: center;
}

.aberto {
  background: #2133d2 !important;
  // background: rgba(33, 51, 210, 0.1) !important;
}

.fraude {
  background: #f41a42 !important;
  // background: rgba(244, 26, 66, 0.1) !important;
}

.alarme {
  background: #ff9900 !important;
  // background: rgba(255, 153, 0, 0.1) !important;
}

.tags {
  padding: 3px 0px;
  text-align: center;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.2px;
  border-radius: 2px;
  background: #f7f7f7;
  color: #333333;
  height: fit-content;
}

.new-tags {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-left: 10px;
}

.grid-sub {
  display: grid;
  grid-template-columns: 25px 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.idsale {
  color: #2133d2;
  font-weight: 600;
}

.button-action {
  width: 35px;
  height: 35px;
  border-radius: 6px;
  border: 1px solid #E5E5E5;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.button-action svg {
  width: 25px;
  height: 25px;
  // background: rgba(33, 51, 210, 0.1);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

.row-info {
  padding: 20px 0px 10px 0px;
  display: flex;
  flex-direction: column;
}

.row-first {
  color: #141414;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
}

.row-second-wrapper {
  display: flex;
  align-items: center;
}

.row-second {
  color: #141414;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 26px;
}

.second-indicator {
  display: flex;
  width: 20px;
  height: 20px;
  padding: 6px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 50%;
  margin-left: 10px;
}

.second-indicator-number {
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.second-indicator-number.blue {
  color: #3682F3;
}

.second-indicator-number.red {
  color: #FF5F5F;
}

.second-indicator.red {
  background-color: #FF5F5F1A;
}

.second-indicator.blue {
  background-color: #3682F31A;
}

.actionContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 12px;
}

.positionRange {
  margin-top: 25px;
}

</style>